import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Container = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`

export const Label = styled(Box)`
  ${({ theme }) => css`
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    line-height: 30px;
    margin-bottom: 24px;
    color: ${theme.colors.secondary};
  `}
`

export const Action = styled(Box)`
  margin-top: 32px;
  margin-bottom: 24px;
`
